<template>
  <!-- Legends -->
  <div
    :class="`col-${sizedLegends}`"
    class="col container-legends_chart_quantity"
    style="padding-top: 15px!important;"
  >
    <div
      class="row f-row"
      style="padding-right: 5px!important; padding-left: 5px!important;"
      v-for="(infoLegend, i) in sortedInfoLegends"
      :key="i"
    >
      <div
        class="col col-10 txt-label-primary-2"
        style="justify-content: flex-start; text-align: left;"
      >
        <template v-if="infoLegend.label === 'Max'">
          Min | Max:
        </template>
        <template v-else>{{ infoLegend.label }}:</template>
      </div>
      <div
        class="col col-2 txt-label-primary-2"
        style="justify-content: center!important;"
      >
        <button
          class="btn detailView"
          v-on:click="onUserShow(`${infoLegend.show}`)"
        >
          <template v-if="isPrices">
            <i
              :class="infoLegend.classNameIcon"
              :style="{
                color: Analytics['userSelections'][`${infoLegend.show}`]
                  ? infoLegend.colorBdr
                  : 'var(--textinactive)',
              }"
            ></i>
          </template>
          <template v-else-if="infoLegend.label === 'Max'">
            <div
              class="square-legends"
              :style="{
                borderColor: 'var(--textactive)',
                color: 'var(--textactive)',
                background: 'var(--transparent)',
                borderStyle: 'dashed solid',
              }"
            ></div>
          </template>
          <template v-else>
            <div
              :class="{
                'square-legends': infoLegend.label !== 'Budget',
                'fa fa-minus': infoLegend.label === 'Budget',
              }"
              :style="{
                borderColor: infoLegend.colorBdr,
                color: Analytics['userSelections'][`${infoLegend.show}`]
                  ? infoLegend.colorBdr
                  : 'var(--textinactive)',
                background: Analytics['userSelections'][`${infoLegend.show}`]
                  ? infoLegend.colorBck
                  : 'var(--transparent)',
              }"
            ></div>
          </template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";

export default {
  name: "CommodityAnalysisSelectors",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics(),
    },
    infoLegends: {
      type: Array,
      required: true,
      default: () => [
        {
          label: "",
          colorBdr: "",
          colorBck: "",
          classNameIcon: "",
          show: "",
        },
      ],
    },
    isPrices: { default: false },
    desiredOrderLegends: { type: Array, required: false, default: () => [""] },
    sizedLegends: {
      type: String,
      required: false,
      default: "1",
    },
  },
  computed: {
    /* Order legends whit the prop desiredOrderLegends */
    sortedInfoLegends() {
      if (!this.desiredOrderLegends || this.desiredOrderLegends.length === 0) {
        return this.infoLegends;
      }

      const mapper = new Map(
        this.desiredOrderLegends.map((v, i) => [v, i + 1]),
      );

      return [...this.infoLegends].sort((a, b) => {
        return (
          (mapper.get(a.label) || Infinity) - (mapper.get(b.label) || Infinity)
        );
      });
    },
  },
  methods: {
    onUserShow(str) {
      this.$emit("eventOnUserShow", str);
    },
  },
};
</script>
